import { Time } from "@internationalized/date"
import { useId } from "react"

import { Box } from "../Box"
import { DateInput } from "../DateInput"
import type { DateInputProps } from "../DateInput/DateInput"
import { FormInputField, type FormInputFieldProps } from "./FormField"

export interface FormDateInputProps
  extends Pick<
    FormInputFieldProps,
    "disabled" | "error" | "sx" | "description"
  > {
  label: string
  value?: Date
  defaultTime?: Time
  mode: DateInputProps["mode"]
  /**
   * The minimum allowed date that a user may select.
   */
  minValue?: "today"
  onValueChange: (value?: Date) => void
}

export function FormDateInput(props: FormDateInputProps) {
  const {
    label,
    sx,
    value,
    defaultTime,
    onValueChange,
    mode,
    minValue,
    disabled = false,
    error,
    description,
  } = props

  const id = useId()

  return (
    <FormInputField
      id={id}
      label={label}
      sx={sx}
      disabled={disabled}
      error={error}
      description={description}
    >
      <Box
        flexDirection="column"
        padding={{ block: 6, inline: 12 }}
        flexGrow={1}
      >
        <DateInput
          aria-labelledby={id}
          mode={mode}
          minValue={minValue}
          value={value}
          onValueChange={onValueChange}
          // When disabled we don't wan't to show the default time, just a placeholder
          defaultTime={disabled ? undefined : defaultTime}
          disabled={disabled}
        />
      </Box>
    </FormInputField>
  )
}
